import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistFamilyLawCase } from "../../Persist/FamilyLawPersister";
import { stageMetaDataBasicCase } from "../../Stages/StagesBasicCase";
import * as basicCaseStages from "../../Stages/StagesBasicCase";
import * as basicCaseStatus from "../../LeadStatus/StatusBasicCase";
import advisoryTransformations from "../FormTransformations/advisoryTransformations";
import { stageFormDefinition as stageFormDefinitionFamily } from "../FormDefinitions/familyLawCase/stageFormDefinition";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionFamilyLawCase } from "../FormDefinitions/familyLawCase/fullFormDefinition";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { FamilyLawCase } from "../../../types/Products/FamilyLaw/FamilyLawCase";

export const familyLawCase: ProductData<FamilyLawCase> = {
  urlPart: "familie",
  lbUrlPart: "erstberatung",
  label: translate("familyLawCase.label"),
  generalLabel: translate("familyLawCase.label"),
  apiUri: "family_law_cases",
  persist: persistFamilyLawCase,
  stages: stageMetaDataBasicCase,
  stageConstants: basicCaseStages,
  minimumCaseStatus: basicCaseStatus.STATUS_CREATED,
  minimumCaseStage: basicCaseStages.STAGE_CREATED,
  setBackCaseStage: basicCaseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\BasicCase\\FamilyLawCase",
  formTransformations: advisoryTransformations,
  formDefinition: ({ product }) => stageFormDefinitionFamily(product),
  formDefinitionExternals: () => formDefinitionExternals["familyLawCase"],
  fullFormDefinition: ({ product }) => fullFormDefinitionFamilyLawCase(product),
  productSpecificDefinition: () => [],
  productCategory: "familyLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.familyLawCase,
};
